import ProfilePresenter from './profilePresenter';
import { useSeekerContainerContext } from '../../SeekerContainerContext';
import { Seeker } from '../../../../../firebase/firestore/documents/seeker';
import useSingleCandidate from '../../../../../app/hooks/useSingleCandidate';
import { Candidate } from '../../../../../firebase/firestore/documents/candidate';
import { useMessagingViewContext, useSelectedEngagedCandidate } from '../../../MessagingViewContext';

type ProfileProps = {
  candidateFromCollaborator?: Candidate | undefined;
  seekerFromCollaborator?: Seeker | undefined;
};

const useProfile = ({
  candidateFromCollaborator,
  seekerFromCollaborator,
}: ProfileProps): { profile: ProfilePresenter; initialized: boolean } => {
  const { selectedSeeker } = useMessagingViewContext();

  const { selectedCandidate } = useSeekerContainerContext();
  const selectedEngagedCandidate = useSelectedEngagedCandidate();
  const c = candidateFromCollaborator || selectedCandidate || /* istanbul ignore next */ selectedEngagedCandidate;

  const candidate = useSingleCandidate(c?.id);
  const seeker = seekerFromCollaborator || selectedSeeker;

  return {
    profile: new ProfilePresenter(seeker, candidate),
    initialized: Boolean(seeker && candidate),
  };
};

export default useProfile;
